// loggedin user details
export const urlKeys = {
  getUserDetailsByIdUrl: "/api/ocup/v1/GetUserDetailsById/",
  getComponentType: "/api/ocup/v1/GetComponentType",
  getComponentTypeApi: "/api/ocup/v1/GetComponentTypeList",
  uploadFirmwareDetails: "/api/ocup/v1/UploadFirmwareFile",
  getIncompatibilityListApi: "/api/ocup/v1/GetIncompatibilityList",
  getFirmwareDetails: "/api/ocup/v1/GetFirmwareDetails",
  addSiteDetailsApi: "/api/ocup/v1/AddSiteDetails",
  addUserDetailsApi: "/api/ocup/v1/AddUserDetails",
  getUserRolesApi: "/api/ocup/v1/GetUserRoles",
  addReleaseDetailsApi: "/api/ocup/v1/AddReleaseDetails",
  getSiteListApi: "/api/ocup/v1/GetSiteList",
  getFirmwareVersionListApi:"/api/ocup/v1/GetFirmwareVersionList",
  deleteFunctionApi: "/api/ocup/v1/DeleteFunction",
  approveAndRejectApi: "/api/ocup/v1/ApproveAndRejectReleaseFunction",
  getReleaseDetailsApi: "/api/ocup/v1/GetReleaseDetails",
  getUserDetailsApi: "/api/ocup/v1/GetUserDetails",
  getSiteDetailsApi: "/api/ocup/v1/GetSiteDetails",
  getFileAlreadyExists: "/api/ocup/v1/FileExists",
  getReportData: "/api/ocup/v1/GetReport",
  getReleaseRejectionReason: "/api/ocup/v1/GetRejectReason",
  updateSiteDetails:"/api/ocup/v1/UpdateSiteDetailsFn",
  updateUserDetails: "/api/ocup/v1/UserUpdateRole",
  updateFirmwareDetails: "/api/ocup/v1/UpdateFirmwareDetailsFn",
  releaseNoteDownload: "/api/ocup/v1/ReleaseNoteDownload",
  addSiteContractDetails: "/api/ocup/v1/AddSiteContractDetails",
  updateSiteContractDetails:"/api/ocup/v1/UpdateSiteContractDetailsFn",
  getSiteContractDetails:"/api/ocup/v1/GetSiteContractDetails",
  getContractComponentType:"/api/ocup/v1/GetContractComponentType",
  getNetworkDiagram:"/api/ocup/v1/GetNetworkDiagram",
  addEmailDomainApi: "/api/ocup/v1/AddDomain",
  getEmailDomainListApi: "/api/ocup/v1/GetDomainList",
};
